var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecentIcon05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.922852,
    width: 60,
    height: 60,
    rx: 10,
    fill: "#FFF6F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1229 36.6667H35.7229V35.9333C35.7229 34.9333 35.2829 34.1387 34.4029 33.5493C33.5229 32.9609 32.3629 32.6667 30.9229 32.6667C29.4829 32.6667 28.3229 32.9609 27.4429 33.5493C26.5629 34.1387 26.1229 34.9333 26.1229 35.9333V36.6667ZM30.9229 31.3333C31.5829 31.3333 32.1481 31.072 32.6185 30.5493C33.0881 30.0276 33.3229 29.4 33.3229 28.6667C33.3229 27.9333 33.0881 27.3053 32.6185 26.7827C32.1481 26.2609 31.5829 26 30.9229 26C30.2629 26 29.6981 26.2609 29.2285 26.7827C28.7581 27.3053 28.5229 27.9333 28.5229 28.6667C28.5229 29.4 28.7581 30.0276 29.2285 30.5493C29.6981 31.072 30.2629 31.3333 30.9229 31.3333ZM21.3229 42C20.6629 42 20.0981 41.7391 19.6285 41.2173C19.1581 40.6947 18.9229 40.0667 18.9229 39.3333V23.3333C18.9229 22.6 19.1581 21.9724 19.6285 21.4507C20.0981 20.928 20.6629 20.6667 21.3229 20.6667H25.1029L27.3229 18H34.5229L36.7429 20.6667H40.5229C41.1829 20.6667 41.7481 20.928 42.2185 21.4507C42.6881 21.9724 42.9229 22.6 42.9229 23.3333V39.3333C42.9229 40.0667 42.6881 40.6947 42.2185 41.2173C41.7481 41.7391 41.1829 42 40.5229 42H21.3229ZM40.5229 39.3333V23.3333H35.6629L33.4729 20.6667H28.3729L26.1829 23.3333H21.3229V39.3333H40.5229Z",
    fill: "#FE4A23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentIcon05);
export default __webpack_public_path__ + "static/media/recent-icon-05.256388705a73674020a2d36bb52fd01a.svg";
export { ForwardRef as ReactComponent };